
import GalhoSeco from '../assets/galho-seco.jpeg'
import InProgress from "../assets/inprogress.svg"
import Keyla from '../assets/keyla.jfif'


export const ProfessionalProjectList = [
    {
        name: "Ateliê Galho Seco",
        image: GalhoSeco,
        description: "Página produzida para o Ateliê Galho Seco"
    },

    {
        name: "Livraria Da Macena",
        image: Keyla,
        description: "Solução para cliente usando a Firestore da Firebase, onde o banco de dados guarda os posts que posteriormente são inseridos na Home, sem precisar que o usuário esteja logado."
    },

    {
        name: "Em progresso",
        image: InProgress,
        description: "Trabalho atualmente em progresso."
    },

    {
        name: "Em progresso",
        image: InProgress,
        description: "Trabalho atualmente em progresso."
    },
]